// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobPreviewPriority-priorityIcon__wJ91Q{color:var(--gray-11)}.JobPreviewPriority-urgentPriorityIcon__Zii8g{color:var(--orange-9)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"priorityIcon": "JobPreviewPriority-priorityIcon__wJ91Q",
	"urgentPriorityIcon": "JobPreviewPriority-urgentPriorityIcon__Zii8g"
};
export default ___CSS_LOADER_EXPORT___;
